let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eZF0Q")).then(() => parcelRequire('8z6iG'));